/*=========================================================================================
  File Name: moduleCalendarMutations.js
  Description: Calendar Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default {
  SET_CATEGORIES(state, categories) {
    state.categories = categories
  },
  SET_CATEGORIES_COUNT(state, count) {
    state.categoriesCount = count
  },
  SET_LIST(state, list) {
    state.list = list
  },
  SET_LIST_COUNT(state, count) {
    state.listCount = count
  },
}